// Back minimises the call instead of leaving the page under it (M70, D267).
// While the full call screen is up we add one history entry at the same URL;
// Back pops it and we minimise. Closing the screen any other way (the
// minimise button, hanging up) takes our entry off again so Back still goes
// where people expect.

const MARK = 'twindenCallScreen';

function isOurs(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as Record<string, unknown>)[MARK] === true
  );
}

// How many holds are live (more than one only for a moment, in StrictMode).
let holds = 0;

// An entry of ours can be left behind: something navigated on top of it
// while the call screen was open (a tapped notification), or the page was
// reloaded. Landing on one with no call screen holding it would make Back
// look like it did nothing, so step over it.
function stepOverLeftovers(event: PopStateEvent) {
  if (holds === 0 && isOurs(event.state)) window.history.back();
}
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', stepOverLeftovers);
}

/**
 * Holds the Back button for the call screen. Returns `release`, to call when
 * the screen closes without Back.
 */
export function holdBackForCall(onBack: () => void): () => void {
  const base =
    typeof window.history.state === 'object' && window.history.state !== null
      ? (window.history.state as Record<string, unknown>)
      : {};
  // React Router keeps its key and index in the state; copying them keeps
  // the location the same, so nothing re-routes.
  window.history.pushState({ ...base, [MARK]: true }, '');
  let held = true;
  holds += 1;

  const onPop = (event: PopStateEvent) => {
    if (!held || isOurs(event.state)) return;
    held = false;
    holds -= 1;
    window.removeEventListener('popstate', onPop);
    onBack();
  };
  window.addEventListener('popstate', onPop);

  return () => {
    window.removeEventListener('popstate', onPop);
    if (!held) return;
    held = false;
    holds -= 1;
    // Only our own entry is taken off: if something navigated meanwhile,
    // going back would undo that instead.
    if (isOurs(window.history.state)) window.history.back();
  };
}
